import Vue from 'vue'
const cache = new Set()

/**
 * 函数式打开弹窗
 * @param component 弹窗组件
 * @param propsData 组件props
 * @param parent 父组件
 * @param eventObj 自定义事件
 * @returns {Promise<unknown>}
 */
export function openDialog({
  component,
  propsData = {},
  parent = undefined,
  eventObj = {}
}) {
  const div = document.createElement('div')
  const el = document.createElement('div')
  const id = 'dialog-' + Math.random()
  div.appendChild(el)
  document.body.appendChild(div)

  const ComponentConstructor = Vue.extend(component)
  let instance = new ComponentConstructor({
    propsData,
    parent
  }).$mount(el)

  const destroyDialog = () => {
    if (cache.has(id)) return
    if (instance && div.parentNode) {
      cache.add(id)
      instance.visible = false
      setTimeout(() => {
        cache.delete(id)
        instance.$destroy()
        instance = null
        div.parentNode && div.parentNode.removeChild(div)
      }, 1000)
    }
  }

  if (instance.visible !== undefined) {
    instance.$watch('visible', val => {
      !val && destroyDialog()
    })
    Vue.nextTick(() => (instance.visible = true))
  }

  // 触发自定义事件
  Object.keys(eventObj).forEach(eventName => {
    instance.$on(eventName, data => eventObj[eventName](data))
  })

  return new Promise((resolve, reject) => {
    instance.$once('confirm', data => {
      destroyDialog()
      resolve(data)
    })
    instance.$once('cancel', data => {
      destroyDialog()
      reject(data)
    })
  })
}
